import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import PasswordInput from "@/components/PasswordInput";

/** Change the password while signed in, plus a shortcut to the support inbox. */
export default function ChangePasswordPanel() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Au moins 6 caractères.");
    if (pw !== pw2) return toast.error("Les deux mots de passe ne sont pas identiques.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      try { localStorage.setItem("metazik_token", data.token); } catch { /* storage blocked */ }
      toast.success("Mot de passe modifié.");
      setCur(""); setPw(""); setPw2(""); setOpen(false);
    } catch (e2) {
      toast.error(!e2.response ? "Le serveur met du temps à répondre." : formatApiError(e2.response.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-3 border-t border-white/5 space-y-3" data-testid="change-password-panel">
      {!open ? (
        <div className="flex items-center justify-between gap-3 text-sm">
          <button type="button" onClick={() => setOpen(true)} className="text-zinc-300 hover:text-white underline" data-testid="change-password-open">Changer mon mot de passe</button>
          <Link to="/support" className="text-zinc-300 hover:text-white underline" data-testid="support-link">Contacter le support</Link>
        </div>
      ) : null}
      {!open ? (
        <div className="flex items-center justify-between gap-3 text-sm">
          <Link to="/faq" className="text-zinc-300 hover:text-white underline" data-testid="faq-link">Questions fréquentes</Link>
          <Link to="/terms" className="text-zinc-300 hover:text-white underline" data-testid="terms-link">Conditions d'utilisation</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          <PasswordInput value={cur} onChange={(e) => setCur(e.target.value)} placeholder="Mot de passe actuel" required dataTestid="cp-current" ariaShow="Afficher" ariaHide="Masquer" />
          <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Nouveau mot de passe" required minLength={6} dataTestid="cp-new" ariaShow="Afficher" ariaHide="Masquer" />
          <PasswordInput value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Répète le nouveau mot de passe" required minLength={6} dataTestid="cp-new2" ariaShow="Afficher" ariaHide="Masquer" />
          <div className="flex gap-2">
            <button type="button" onClick={() => setOpen(false)} className="btn-secondary flex-1">Annuler</button>
            <button type="submit" disabled={busy} className="btn-primary flex-1 disabled:opacity-60" data-testid="cp-submit">Enregistrer</button>
          </div>
        </form>
      )}
    </div>
  );
}
